/**
 * ¿Es GSG este courier? Por nombre exacto, no por «contiene»: `includes('eva')` ya le pasó a Eva con
 * cualquier courier que tuviera esas tres letras. La fila la crea 20260929170000 con el nombre «GSG».
 *
 * 🪤 VIVE SOLA, SIN IMPORTS, A PROPÓSITO. Estaba en `conexionGsg.ts`, que al cargarse arma la URL del webhook
 *    con la de Supabase: el rótulo la importó para esta pregunta de una línea, y el candado visual —que
 *    dibuja la lista sin esa variable— se cayó entero («Invalid URL», 0 filas). Una pregunta así no puede
 *    arrastrar la configuración de red.
 */
export function esGsg(nombre: string | null | undefined): boolean {
  return (nombre ?? '').trim().toLowerCase() === 'gsg';
}
